/**
 * Base classes for the component.
 * @type {String}
 */
export const BASE_CLASSES = 'fit-input';

/**
 * the inner icon's base class.
 * @type {String}
 */
export const BASE_ICON_CLASS = 'fit-input-icon';

/**
 * Possible icon positions.
 * @type {Object<String>}
 */
export const ICON_POSITIONS = {
    START: 'start',
    END: 'end'
};
